// PostHog provider, hooks, and direct client access.
// All PostHog integration code lives here — including the event-name registry
// at `./events/<Feature>/`.

import posthog from 'posthog-js'

export {
  GaiaPostHogProvider,
  EventContextProvider,
  ChatSessionContextProvider,
} from './PostHogProvider'
export type { PostHogEventContext } from './PostHogProvider'

export { usePostHogEvent } from './usePostHogEvent'

export { POSTHOG_FEATURE_FLAGS } from './flags'

export type {
  PostHogEventSignatures,
  PostHogEventName,
  AIEvents,
  OracleEvents,
  VideoPlayerEvents,
  CommunityEvents,
  AiInputMethod,
  AiSubmissionMethod,
  AiFeedbackUiElement,
  AiRecommendationPayload,
  DivinationChannel,
  CommunityHeaderLinkSource,
  CommunityLibraryTab,
  CommunityPlaylistType,
  CommunityPlaylistCreationMethod,
  CommunityPlaylistCreatedDetails,
  CommunityPlaylistSmartCreateSource,
  CommunityShareMethod,
  CommunityConnectionsTab,
} from './events'

// Re-export the raw posthog-js client for feature-flag access
// (posthog.getFeatureFlag, posthog.isFeatureEnabled, etc.).
// Prefer this over importing 'posthog-js' directly so all PostHog access
// goes through one entrypoint.
export { posthog }
